<script>
  import extoleSvc from '@services/extoleSvc';

  export default {
    name: 'ExtoleTag',

    props: {
      method: {
        type: String,
        required: true
      },
      args: {
        type: Array,
        default: () => []
      }
    },

    render() {
      return null;
    },

    data() {
      return {
        loading: false,
        error: null,
        result: null
      };
    },

    async mounted() {
      this.loading = true;
      this.error = null;

      try {
        const fn = extoleSvc[this.method];
        if (typeof fn !== 'function') {
          throw new Error(`Method ${this.method} not found in extoleSvc`);
        }
        const result = await fn(...this.args);
        this.result = result;
        this.$emit('success', result);
        this.loading = false;
      } catch (e) {
        this.error = e;
        this.$emit('error', e);
        this.loading = false;
      }
    }
  };
</script>
